'use client';

import React, { useState } from 'react';
import { ChromePicker, ColorResult } from 'react-color';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

type InputColorType = {
  defaultColor?: string;
  label?: string;
  className?: string | undefined;
  onChangeColor?: (color: string) => void;
};

export default function InputColor({
  defaultColor,
  className,
  label,
  onChangeColor,
}: InputColorType) {
  const [color, setColor] = useState(defaultColor);

  const onChange = (c: ColorResult) => {
    if (c.rgb) {
      const stringColor = `rgb(${c.rgb.r},${c.rgb.g},${c.rgb.b})`;

      onChangeColor?.(stringColor);
      setColor(stringColor);
    }

    if (c.hex) {
      const stringColor = c.hex;

      onChangeColor?.(stringColor);
      setColor(stringColor);
    }
  };

  return (
    <div className='mb-4 flex items-center space-x-3'>
      <div className='h-9 w-9'>
        <Popover>
          <PopoverTrigger>
            <div
              className='h-9 w-9 rounded border border-[#E4E2E2]'
              style={{ backgroundColor: `${color}` }}
            >
              {!color && (
                <svg
                  width='36'
                  height='34'
                  viewBox='0 0 46 47'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <line x1='45.3574' y1='0.349647' x2='0.357418' y2='46.3497' stroke='#DF4D4D' />
                </svg>
              )}
            </div>
          </PopoverTrigger>
          <PopoverContent>
            <ChromePicker
              color={color}
              className={className}
              onChange={onChange}
              disableAlpha={true}
            />
          </PopoverContent>
        </Popover>
      </div>
      <div className='w-full'>
        <div className='font-bold'>{label}</div>
        <div>{color}</div>
      </div>
      <style jsx global>
        {`
          .chrome-picker {
            box-shadow: none !important;
            width: 100% !important;
          }
          .chrome-picker > div:nth-child(1) {
            border-radius: 10px !important;
          }
          .chrome-picker > div:nth-child(2) {
            padding: 14px 0px !important;
          }
        `}
      </style>
    </div>
  );
}
